import React from "react";
import { FaDrawPolygon, FaRulerCombined, FaTimes } from "react-icons/fa";

import { formatAreaHa, formatDistanceM } from "../utils/mapMeasurements";

import "./MapTrackMeasureToolbar.css";

function formatGaps(gaps) {
  if (!gaps || !gaps.length) return "—";
  return gaps.map((gap) => formatDistanceM(gap)).join(" · ");
}

export default function MapTrackMeasureToolbar({
  t,
  measure,
  onStartArea,
  onStartTape,
  onFinishArea,
  onClear,
}) {
  const translate = t || ((value) => value);
  const tool = measure && measure.tool;
  const result = measure && measure.result;
  const canFinishArea = tool === "area" && measure.draftCount >= 3 && !(result && result.kind === "area");

  return (
    <div className="track-measure-tools">
      <div className="track-measure-toolbar">
        <button
          type="button"
          className={`btn btn-default btn-sm ${tool === "area" ? "is-active" : ""}`}
          onClick={onStartArea}
          title={translate("Medir a área do quadrante trabalhado")}
        >
          <FaDrawPolygon />
          {translate("Medir área")}
        </button>
        <button
          type="button"
          className={`btn btn-default btn-sm ${tool === "tape" ? "is-active" : ""}`}
          onClick={onStartTape}
          title={translate(
            "Trena transversal: cruza vários rastros e calcula a média da passada"
          )}
        >
          <FaRulerCombined />
          {translate("Trena")}
        </button>
        {canFinishArea ? (
          <button type="button" className="btn btn-primary btn-sm" onClick={onFinishArea}>
            {translate("Concluir")}
          </button>
        ) : null}
        {tool || result ? (
          <button
            type="button"
            className="btn btn-default btn-sm"
            onClick={onClear}
            title={translate("Limpar medição")}
          >
            <FaTimes />
            {translate("Limpar medição")}
          </button>
        ) : null}
      </div>

      {tool && !result ? (
        <div className="track-measure-panel">
          {tool === "tape" ? (
            <p>
              {translate(
                "Clique em um rastro e puxe a trena na transversal (90° ao deslocamento). A média usa vários rastros por causa do erro de GPS."
              )}
            </p>
          ) : (
            <p>
              {translate(
                "Clique para marcar os vértices da área. Clique duas vezes ou use Concluir."
              )}
            </p>
          )}
        </div>
      ) : null}

      {result && result.kind === "area" ? (
        <div className="track-measure-panel">
          <h4>{translate("Área medida")}</h4>
          <div className="track-measure-row">
            <span>{translate("Área")}</span>
            <strong>{formatAreaHa(result.areaHa)}</strong>
          </div>
          <div className="track-measure-row">
            <span>{translate("Perímetro")}</span>
            <strong>{formatDistanceM(result.perimeterM)}</strong>
          </div>
        </div>
      ) : null}

      {result && result.kind === "tape" ? (
        <div className="track-measure-panel">
          <h4>
            {result.crossingCount >= 2
              ? translate("Largura de passada")
              : translate("Distância")}
          </h4>
          <div className="track-measure-row">
            <span>{translate("Trena")}</span>
            <strong>{formatDistanceM(result.tapeLengthM)}</strong>
          </div>
          {result.crossingCount >= 2 ? (
            <>
              <div className="track-measure-row">
                <span>{translate("Rastros cruzados")}</span>
                <strong>{result.crossingCount}</strong>
              </div>
              <div className="track-measure-row">
                <span>{translate("Soma entre rastros")}</span>
                <strong>{formatDistanceM(result.gapSumM)}</strong>
              </div>
              <div className="track-measure-row track-measure-row--avg">
                <span>{translate("Média da passada")}</span>
                <strong>{formatDistanceM(result.gapAverageM)}</strong>
              </div>
              <p className="track-measure-gaps">
                {translate("Intervalos")}: {formatGaps(result.gaps)}
              </p>
            </>
          ) : result.crossingCount === 1 ? (
            <p className="track-measure-gaps">
              {translate("Puxe a trena por cima de mais rastros para calcular a média.")}
            </p>
          ) : (
            <p className="track-measure-gaps">
              {translate("Nenhum rastro cruzado. Clique no rastro para travar a transversal.")}
            </p>
          )}
        </div>
      ) : null}
    </div>
  );
}
